import {Select, CircularProgress, Grid, TableContainer, Table, Paper, TableHead, TableRow, TableCell, TableBody, FormControl, Button} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import {useState} from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_LOCATION, TAB_ASSO} from './StatsCommon.js';
import StatsFilter from './StatsFilter.js';
import {LocationSrc} from './StatsLoc.js';
import {COMM_OK} from '../WsR2.js';

const StatsAsso = observer((props) => {
	const [loading, setLoading] = useState(false);
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function statsAssoYearChange(event) {
		gStorage.stats.setStatsYear(event.target.value);
		gStorage.stats.setObsList(null);
	}

	function statsAssoAssoChange(event) {
		gStorage.stats.setAssociation(parseInt(event.target.value, 10));
		gStorage.stats.setObsList(null);
	}

	function assoStatsRxWs(status, msg) {
		setLoading(false);

		if (status !== COMM_OK) {
			alert('assoStatsRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('assoStatsRxWs: ' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_LOCATION || gStorage.stats.loc_tab !== TAB_ASSO)
			return;

		// console.log('assoStatsRxWs', msg);
		gStorage.stats.setObsList(msg.data.list);
	}

	function loadAssoStats() {
		let city_array = [];

		Array.prototype.push.apply(city_array, gStorage.lists.assolist.list.find(a => a.id === gStorage.stats.association).cities);

		if (city_array.length <= 0)
			return assoStatsRxWs(COMM_OK, {result: 'OK', data: {list: []}});

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'location',
			op: 'list',
			data: {
				loc_arr: city_array,
				addr: '',
				year: gStorage.stats.statsYear,
			},
		}

		// console.log('loadAssoStats', msg);
		setLoading(true);
		gStorage.conn.ws.send(msg, assoStatsRxWs);
	}

	function assoAddLeftEnabled() {
		return gStorage.stats.association !== 0 && gStorage.stats.obsList && gStorage.stats.obsList.length !== 0 &&
			(gStorage.stats.rightList.tab !== TAB_ASSO || gStorage.stats.rightList.location !== gStorage.stats.association || gStorage.stats.rightList.year !== gStorage.stats.statsYear);
	}
	
	function assoAddLeft() {
		gStorage.stats.setLeftList({...gStorage.stats.leftList, tab: TAB_ASSO, location: gStorage.stats.association, year: gStorage.stats.statsYear, list: gStorage.stats.obsList.slice()});
	}

	function assoAddRightEnabled() {
		return gStorage.stats.association !== 0 && gStorage.stats.obsList && gStorage.stats.obsList.length !== 0 &&
			(gStorage.stats.leftList.tab !== TAB_ASSO || gStorage.stats.leftList.location !== gStorage.stats.association || gStorage.stats.leftList.year !== gStorage.stats.statsYear);
	}
	
	function assoAddRight() {
		gStorage.stats.setRightList({...gStorage.stats.rightList, tab: TAB_ASSO, location: gStorage.stats.association, year: gStorage.stats.statsYear,  list: gStorage.stats.obsList.slice()});
	}

	if (gStorage.stats.tab !== TAB_LOCATION || gStorage.stats.loc_tab !== TAB_ASSO)
		return null;


	if (loading) {
		return (
			<Grid direction="column" justifyContent="center" alignItems="center" spacing={0}>
				<CircularProgress sx={{mt: 10}} enableTrackSlot/>
			</Grid>
		)
	}

	if (!gStorage.stats.obsList) {
		if (gStorage.conn.online) {
			if (gStorage.stats.association) {
				loadAssoStats();
				return null;
			}
		}
	}

	return (
		<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
			<Grid 
			    style={{width: 300}}
			    size={{xs: 12}} 
			    align={'center'}
			>
				<FormControl>
					<div>
						<Button disabled={!assoAddLeftEnabled()} onClick={assoAddLeft}>
							L&nbsp;
							<AddCircleOutlineIcon/>
						</Button>

						&nbsp;&nbsp;&nbsp;&nbsp;

						<Select native
							size='small'
							value={gStorage.stats.association}
							onChange={statsAssoAssoChange}
							disabled={!gStorage.conn.online}
							sx={{mb: 1}}
						>
							<option value={0} key={0}>--</option>
							{gStorage.lists.assolist.list.toSorted((a, b) => a.nick.localeCompare(b.nick, 'fi')).map((val) => 
								<option value={val.id} key={val.id}>{val.nick}</option>)}
						</Select>

						&nbsp;&nbsp;&nbsp;&nbsp;

						<Button disabled={!assoAddRightEnabled()} onClick={assoAddRight}>
							<AddCircleOutlineIcon/>
							&nbsp;R
						</Button>
					</div>
				</FormControl>

				<StatsFilter 
					time = {{
						year: {
							year: gStorage.stats.statsYear,
							onChange: statsAssoYearChange,
							enabled: gStorage.conn.online && gStorage.stats.association,
							allowNone: true
						}}
					}
				/>
			</Grid>

			{gStorage.stats.obsList &&
			<TableContainer component={Paper} elevation={0}>
				<Table size='small'>
					<TableHead>
						<TableRow>
							<TableCell>#</TableCell>
							<TableCell>{t('main.species')}</TableCell>
							<TableCell>{t('main.time')}</TableCell>
							<TableCell>{t('main.location')}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						<LocationSrc arr={gStorage.stats.obsList} />
					</TableBody>
				</Table>
			</TableContainer>}
		</Grid>
	)
});

export default StatsAsso;
